import { reactive, toRefs } from '@vue/composition-api'
import { getBase64 } from '@/utils/util'

const byte = 1024 * 5 * 1024

export default () => {
  const state = reactive({
    path_list: [],
    copy_left_top_list: [],
    copy_right_bottom_list: [],

    previewImage: '', // 图片预览
    previewVisible: false, // 图片预览
  })

  const methods = {
    // 选择图片
    handleChange(type, { file, fileList }, idx) {
      const status = fileList[0]?.status
      this[`${type}_list`] = fileList
      if (status === 'done') {
        const url = fileList[0].response.data.url
        if (type === 'path') {
          this.form[type] = `${this.QI_NIU_DOMAINS}/${url}`
        }
        if (type.startsWith('copy')) {
          this.form.vice_img[idx] = url
        }
      }
    },
    handleBeforeUpload(file, type) {
      const size = file.size
      if (size > byte) {
        this.$message.warning('图片超出5M咯!')
        setTimeout(() => {
          if (type.includes('indexList')) {
            const [ origin, index, types ] = type.split('_')
            this[`${types}_list`] = []
          }
          this[`${type}_list`] = []
        })
        return false
      }
      if (!file.name.endsWith('.jpg') && !file.name.endsWith('.jpeg') && !file.name.endsWith('.png') && !file.name.endsWith('.gif')) {
        this.$message.warning('图片格式只能为jpg, jpeg, png, gif')
        setTimeout(() => {
          if (type.includes('indexList')) {
            const [ origin, index, types ] = type.split('_')
            this[`${types}_list`] = []
          }
          this[`${type}_list`] = []
        })
        return false
      }
      return true
    },
    handleRemove(type, idx) {
      if (type === 'path') {
        this.form[type] = ''
      }
      if (type.startsWith('copy')) {
        this.form.vice_img.splice(idx, 1)
      }
    },
    handleEchoImg(data) {
      state.path_list.push({ uid: Date.now(), name: `${Date.now()}`, status: 'done', url: data.path })
      data.vice_img[0] && state.copy_left_top_list.push({ uid: Date.now(), name: `${Date.now()}`, status: 'done', url: `${this.QI_NIU_DOMAINS}/${data.vice_img[0]}` })
      data.vice_img[1] && state.copy_right_bottom_list.push({ uid: Date.now(), name: `${Date.now()}`, status: 'done', url: `${this.QI_NIU_DOMAINS}/${data.vice_img[1]}` })
      if (this.form.demo_picture !== '') {
        this.defaultFileList.push({
          uid: +new Date(),
          name: this.form.demo_picture,
          status: 'done',
          url: this.form.demo_picture
        })
      }
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    }
  }

  return {
    ...toRefs(state),
    ...methods
  }
}
